var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMessageActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M6.356,254.388a13.748,13.748,0,0,1-4.073-8.427,8.777,8.777,0,0,0-1.9,5.484,8.878,8.878,0,0,0,.853,3.78L.087,258.568a1.58,1.58,0,0,0,1.488,2.093,1.59,1.59,0,0,0,.517-.087l3.344-1.149a8.878,8.878,0,0,0,3.78.853,8.78,8.78,0,0,0,5.574-1.973A13.761,13.761,0,0,1,6.356,254.388Z",
    transform: "translate(0 -232.661)",
    fill: "#ffcfe9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M93.823,26.083l-1.62-4.8a12.222,12.222,0,0,0,1.2-5.253,12.043,12.043,0,0,0-3.383-8.422,11.613,11.613,0,0,0-16.725-.082,12.142,12.142,0,0,0,.08,17.038,11.6,11.6,0,0,0,8.249,3.446h.019A11.637,11.637,0,0,0,86.8,26.791l4.714,1.65A1.785,1.785,0,0,0,93.389,28,1.867,1.867,0,0,0,93.823,26.083Zm-11.065-5.91H76.677a.846.846,0,0,1,0-1.691h6.082a.846.846,0,0,1,0,1.691ZM86.565,16.7H76.677a.846.846,0,0,1,0-1.691h9.889a.846.846,0,0,1,0,1.691Zm0-3.477H76.677a.846.846,0,0,1,0-1.691h9.889a.846.846,0,0,1,0,1.691Z",
    transform: "translate(-65.924 -4.011)",
    fill: "#ffcfe9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageActive);
export default __webpack_public_path__ + "static/media/icon_message_active.a3642e65817535ae4c51e137718ab85c.svg";
export { ForwardRef as ReactComponent };